import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const UserService = new ModelService(apiRoutes.users, '/users', 'users');

UserService.createInvite = async model => api.catchError(async () => {
  const { data } = await api.post(apiRoutes.createInvite, model);
  return data;
});

UserService.defaultAvatar = `${api.baseUrl}/default_avatar.png`;

UserService.getAvatar = (filename, w = false, h = false, c = false) => {
  if (!filename) return UserService.defaultAvatar;
  return UserService.getFilePathByDir('/uploads/users', filename, w, h, c);
};

UserService.STATUS_ACTIVE = 1;
UserService.STATUS_INACTIVE = 0;
UserService.STATUS_UNDER_REVIEW = 2;
UserService.STATUS_PENDING = 3;

UserService.getStatusList = t => ({
  [UserService.STATUS_ACTIVE]: t('Active'),
  [UserService.STATUS_INACTIVE]: t('Inactive'),
  [UserService.STATUS_UNDER_REVIEW]: t('Under review'),
  [UserService.STATUS_PENDING]: t('Pending'),
});

UserService.getStatusOptions = t => UserService
  .prepareOptionsFromSimpleObject(UserService.getStatusList(t));

UserService.getStatusTitle = (status, t) => {
  const label = UserService.getStatusList(t)[status];
  return label || '-';
};

UserService.getColorByStatus = (status) => {
  switch (status) {
    case UserService.STATUS_ACTIVE:
      return 'success';
    case UserService.STATUS_INACTIVE:
      return 'danger';
    case UserService.STATUS_UNDER_REVIEW:
      return 'warning';
    case UserService.PENDING:
      return 'warning';
    default:
      return 'secondary';
  }
};

export default UserService;



// WEBPACK FOOTER //
// ./src/services/user.service.js